export default __webpack_public_path__ + "static/media/screen_google_calendar_03.b26ed70d.png";